import DefaultElementNodeType from '../DefaultElementNodeType';
import {APPLICATION_INTERACTION} from '../../metamodel/Concept';

export default class ApplicationInteractionNodeType extends DefaultElementNodeType {
	static get typeName() {
		return APPLICATION_INTERACTION;
	}
}
